import type { Hunt } from '@wehunt/ui'
import type { DraftHuntDto } from './useDraftHunts'

function pad2(n: number): string {
  return n.toString().padStart(2, '0')
}

export const DRAFT_STEP_NAMES = [
  'Basics',
  'Leaders',
  'Participants',
  'Invitation',
  'Drives',
  'Game',
] as const

export function draftDtoToHunt(dto: DraftHuntDto): Hunt {
  const start = new Date(dto.startTime)
  const end = dto.endTime ? new Date(dto.endTime) : start
  const quarry = dto.huntableGames.length > 0 ? dto.huntableGames.join(', ') : '—'
  const stepIdx = Math.min(DRAFT_STEP_NAMES.length - 1, Math.max(0, dto.lastStepIndex ?? 0))
  return {
    id: dto.id,
    date: `${start.getFullYear()}-${pad2(start.getMonth() + 1)}-${pad2(start.getDate())}`,
    start: `${pad2(start.getHours())}:${pad2(start.getMinutes())}`,
    end: `${pad2(end.getHours())}:${pad2(end.getMinutes())}`,
    team: dto.groupName,
    teamId: dto.groupId,
    quarry,
    // Empty when unnamed, so the card falls back to the team name via
    // huntDisplayName — not a hardcoded, untranslated "Untitled draft" literal.
    location: dto.huntName || '',
    participants: dto.participantCount,
    dogs: [],
    status: 'draft',
    lastStepIndex: stepIdx,
    draftStep: `Step ${stepIdx + 1} of ${DRAFT_STEP_NAMES.length} — ${DRAFT_STEP_NAMES[stepIdx]}`,
  }
}
